/**
 * Report Type Constants
 *
 * These constants define the reporting periods that can be selected on the
 * annual report page and their corresponding display labels in German.
 * Selecting a type pre-fills the date range with the last completed period
 * (see `getReportPeriodRange` in `utils/helper.ts`).
 */

export interface ReportTypeOption {
  id: string;
  label: string;
}

export const REPORT_TYPES = {
  ANNUAL: "annual_report",
  QUARTERLY: "quarterly_report",
  MONTHLY: "monthly_report",
} as const;

export type ReportType = (typeof REPORT_TYPES)[keyof typeof REPORT_TYPES];

/**
 * Mapping of report type IDs to their German display labels
 * Single source of truth for all report type translations
 */
export const REPORT_TYPE_LABELS: Record<string, string> = {
  [REPORT_TYPES.ANNUAL]: "Jahresbericht",
  [REPORT_TYPES.QUARTERLY]: "Quartalsbericht",
  [REPORT_TYPES.MONTHLY]: "Monatsbericht",
};

export const REPORT_TYPE_OPTIONS: ReportTypeOption[] = [
  REPORT_TYPES.ANNUAL,
  REPORT_TYPES.QUARTERLY,
  REPORT_TYPES.MONTHLY,
].map((id) => ({ id, label: REPORT_TYPE_LABELS[id] }));
